
/* injects from baggage-loader */

'use strict';

/**
 * Constants to use in the seller search module.
 */
const sellerSearchConstant = {
	NOT_FOUND_SELLERS: 'No se pudieron adquirir los vendedores',
	SELLER_LABEL: 'Vendedor'
};

export default sellerSearchConstant;



// WEBPACK FOOTER //
// ./src/app/core/components/sellerSearch/sellerSearch.constant.js